

























import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {getCurrentTime} from "@/utils/base";
import {
  GetTemList,
  EditContent,
  PostCepingContent,
  GetContentDetail,
} from "@/request/common";
import TemplateContent from "@/components/template-transfer-pc/template/template-content.vue";

@Component({
  components: {
    TemplateContent,
  },
})
export default class Name extends Vue {
  @Prop()
  private dataQuery: any;
  @Prop()
  private visible: any;

  @Watch("visible", {immediate: true})
  private visibleChange() {
    this.ifShow = this.visible;
    if (this.visible) {
      this.$store.commit("updateIfCompose", true);
      this.getData();
    } else {
      this.$store.commit("updateIfCompose", false);
    }
  }

  private ifShow: any = false;
  private data: any = [];

  private get user() {
    return this.$store.state.user;
  }

  private get patient() {
    return this.$store.state.patient;
  }

  private get bmiInfo() {
    return this.$store.state.bmiInfo;
  }

  private get ifCompose() {
    return this.$store.state.ifCompose;
  }

  private cancel() {
    this.$emit("cancel");
  }

  private getData() {
    if (this.dataQuery.content_id) {
      this.getContent();
    } else {
      this.getTemplate();
    }
  }

  private getTemplate() {
    const params: any = {
      params: {
        name: this.dataQuery.name,
        page: 1,
        ignore_permissions: "true",
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemList(this, params, loading).then((res: any) => {
      res.data[0].fields.forEach((item: any) => {
        if (item.title === '身高') {
          item.value = this.bmiInfo.height;
        } else if (item.title === '体重') {
          item.value =  this.bmiInfo.weight;
        }
        // 其他 title 保持不变
      });
      this.data = {
        template: {
          id: res.data[0].id,
        },
        collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
        data: res.data[0].fields,
      };
    });
  }

  private getContent() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetContentDetail(this, this.dataQuery.content_id, loading).then(
        (res: any) => {
          this.data = res.data;
        }
    );
  }

  private updateContent(e: any) {
    this.data = e;
  }

  save() {
    return new Promise((resolve, reject) => {
      (this.$refs.templateContent as any).savePre().then((res: any) => {
        if (res) {
          // 必填验证成功
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          if (this.dataQuery.content_id) {
            EditContent(
                this,
                this.dataQuery.content_id,
                this.data,
                loading
            ).then((res: any) => {
              this.$message.success("保存成功！");
              this.cancel();
              this.$emit("refreshJiancha");
              resolve(true);
            });
          } else {
            const params: any = {
              collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
              patient: this.patient.id,
              data: this.data.data,
              template: {
                id: this.data.template.id,
              },
            };
            PostCepingContent(this, params, loading).then((res: any) => {
              this.$message.success("保存成功！");
              this.cancel();
              this.$emit("refreshJiancha");
              resolve(res);
            });
          }
        } else {
          // 必填验证失败
        }
      });
    });
  }
}
